import { useMutation } from '@tanstack/react-query';
import { AxiosError, AxiosResponse } from 'axios';
import { showNotification } from '@mantine/notifications';
import { useAuth } from '@/contexts/AuthContext';
import { getUserByToken, UserResponse } from '@/services/api/auth/auth.service';

export const useGetUserByTokenMutation = () => {
  const { saveAuth, setCurrentUser } = useAuth();

  const {
    data: dataUserByToken,
    isPending: isPendingUserByToken,
    isSuccess: isSuccessUserByToken,
    mutateAsync: mutateAsyncUserByToken,
    ...rest
  } = useMutation({
    mutationFn: async () => {
      return await getUserByToken();
    },
    onSuccess: async (resp: AxiosResponse<UserResponse>) => {
      const { data } = resp;
      setCurrentUser(data);
    },
    onError: (error: AxiosError) => {
      saveAuth(undefined);
      if (error.response) {
        const responseData = error.response.data as { message: string; code: number };

        showNotification({
          color: 'red',
          title: 'Erro no login',
          message: `code: ${responseData.code} - ${responseData.message}`,
        });
      }
    },
  });

  return {
    dataUserByToken,
    isPendingUserByToken,
    isSuccessUserByToken,
    mutateAsyncUserByToken,
    ...rest,
  };
};
